import type { IconSvgObject } from './types';

const CommentAdd01Icon: IconSvgObject = [
  ["path", { d: "M21.9983 11.5V15.9971C21.9983 17.1016 21.1029 17.9971 19.9983 17.9971H11.499L7.58719 20.842C6.92623 21.3227 5.99902 20.8506 5.99902 20.0333V17.9971H4C2.89543 17.9971 2 17.1016 2 15.9971V4C2 2.89543 2.89543 2 4 2H12.5", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: "1.5", key: "0" }],
  ["path", { d: "M22 5.5H15M18.5 2V9", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: "1.5", key: "1" }],
  ["path", { d: "M8 13H14M8 8H10.5", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: "1.5", key: "2" }]
];

export default CommentAdd01Icon;
